import React, { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
// remove after types update for v6
// @ts-ignore
import { useLocation, useNavigate } from "react-router-dom";
import {
  getWithdrawalsInformation,
  getPendingWithdrawOpen,
  getPendingWithdrawContent
} from "@tvg/sh-lib-paws/redux/selectors";
import WithdrawalsComponent from "@tvg/withdrawals";
import ModalV2 from "@tvg/atomic-ui/_templates/ModalV2";
import { togglePendingWithdraw } from "@tvg/sh-lib-paws/redux/slices/pendingWithdrawSlice";
import { usePendingWithdrawsModalState } from "@tvg/sh-lib-paws/hooks/usePendingWithdrawsModalState";
import {
  PendingWithdrawContent,
  PendingWithdrawVisibilityToggle,
  WithdrawalsInfo
} from "../../types";

export const PendingWithdrawalsModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { isOpen }: PendingWithdrawVisibilityToggle = useSelector(
    getPendingWithdrawOpen
  );

  const {
    isCancelModalOpen,
    closeCancelWithdrawal,
    showPendingWithdrawalsV2
  }: WithdrawalsInfo = useSelector(getWithdrawalsInformation);

  const { cancelModalContent }: PendingWithdrawContent = useSelector(
    getPendingWithdrawContent
  );

  usePendingWithdrawsModalState();

  const props = {
    title: isCancelModalOpen ? cancelModalContent.title : "Pending Withdrawals",
    isOpen: showPendingWithdrawalsV2 && isOpen,
    qaLabel: "modal-pendingWithdrawals",
    animation: "fade",
    fixedWidth: "375px",
    offsetTop: 0,
    isTitleCenter: !isCancelModalOpen,
    onClose: () => {
      dispatch(togglePendingWithdraw(false));
      navigate(`${location.pathname}${location.search}`);
    },
    onBack:
      isCancelModalOpen && closeCancelWithdrawal ? closeCancelWithdrawal : null,
    titleType: "default",
    useModalHeaderV3: true,
    showBottomShadow: false,
    hasOverlay: true,
    isFullWidth: false,
    hasRoundedCorners: true,
    isFullHeight: false
  };

  return (
    <ModalV2 {...props}>
      {() => (
        <WithdrawalsComponent
          dispatch={dispatch}
          device="tablet"
          closeModalCallback={() => {
            dispatch(togglePendingWithdraw(false));
            navigate(`${location.pathname}${location.search}`);
          }}
          isApp={false}
        />
      )}
    </ModalV2>
  );
};

export default memo(PendingWithdrawalsModal);
